module.exports = __webpack_public_path__ + "img/itc.999cd8a6.svg";